// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"index_drawerContainer__Ln_0V","fullMobile":"index_fullMobile__1ZTL8","modalFooter":"index_modalFooter__1YMVc","pageFooter":"index_pageFooter__1NJEB"};